import styled from "styled-components";
import theme from "../../theme/theme";

export const MainWrapper = styled.div`
  margin: 0 13% 5% 13%;

  @media (max-width: 400px) {
    margin: 0 7% 5% 7%;
  }
`;

export const MainHeader = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  color: ${theme.color.navy};
  margin: 40px 0 -30px 0;

  @media (max-width: 640px) {
    font-size: 2.5rem;
  }
`;

export const StatsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  margin: 0 6% 0 6%;
  align-items: center;
  @media (max-width: 800px) {
    margin: 0;
    justify-content: center;
    gap: 20px;
  }
  // @media (max-width: 1500px) {
  // margin: 0 5% 0 5%;
  // }

  @media (max-width: 1100px) {
    margin: 0;
  }
`;
